import React, { useContext, useRef } from 'react';
import Title from '../resources/Title';
import { MainContext } from '../../context/MainContext'
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import { DataGrid } from '@mui/x-data-grid';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import * as Constants from '../api/constants'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Grid from '@mui/material/Grid';

function createData(id, email, firstName, lastName, notifications, deleteDealer) {
  return { id, email, firstName, lastName, notifications, deleteDealer };
}

let rows = [];

const cellRenderer = (params) => {
  return params.value;
};

export default function UsersList(props) {
  const dealerList = useContext(MainContext);

  const parent = props;
  const [open, setOpen] = React.useState(false);
  const [dealerUserId, setDealerUserId] = React.useState(0);

  let columns = [
    { field: 'id', headerName: 'ID', width: 80 },
    { field: 'email', headerName: 'Email', flex: 2, minWidth: 250 },
    { field: 'firstName', headerName: 'First Name', flex: 1, minWidth: 120 },
    { field: 'lastName', headerName: 'Last Name', flex: 1, minWidth: 120 },
    { field: 'notifications', headerName: 'Notifications', flex: 1, minWidth: 60, renderCell: cellRenderer },
    { field: 'deleteDealer', headerName: 'Remove', flex: 1, minWidth: 100, renderCell: cellRenderer },
  ];

  rows = [];

  const tfName = useRef('');
  const tfEmail = useRef('');
  const [selectionModel, setSelectionModel] = React.useState([])

  const [data, setData] = React.useState(rows);
  React.useEffect(() => {
    [...dealerList].forEach(element => {
      rows.push(createData(element.id, element.email, element.firstName, element.lastName,
        <FormControlLabel control={<Checkbox defaultChecked={element.notification} />} label="" onChange={(event) => handleCheckboxChange(event, element.id)} style={{ margin: 'auto', display: 'block' }} />,
        <Button variant="contained" color="error" type="submit" onClick={() => { handleDeleteClickOpen(element.id) }}>Remove</Button>))
    });

    setData(rows)
  }, [dealerList])

  const handleCheckboxChange = (event, id) => {

    console.log('Checkbox state changed:', event.target.checked);
    console.log('Checkbox ID:', id);

    const requestOptions = {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        UserId: id,
        EnableNotification: event.target.checked
      }),
      credentials: "include"
    };

    fetch(Constants.baseURL + Constants.apiUpdateDealerNotification, requestOptions)
      .then((response) => {
        if (response.ok) {
          parent.getDealersList();
        } else {
          window.location.reload();
        }
      }).catch(error => { console.log('request failed', error); });
  };

  const handleSearch = () => {
    parent.getDealersList(tfName.current.value, tfEmail.current.value);
  };

  const onChangeHandler = (ev) => {
    if (tfName.current.value === '' && tfEmail.current.value === '' && ev.key !== 'Enter') {
      parent.getDealersList(tfName.current.value, tfEmail.current.value);
    }
  }

  const handleSelectionModelChange = (newSelection) => {
    // Allow only one selection
    if (newSelection.length > 1) {
      setSelectionModel([newSelection[newSelection.length - 1]]);
      parent.getSpasList("", "", "", [newSelection[newSelection.length - 1]])
    } else {
      setSelectionModel(newSelection);
      parent.getSpasList("", "", "", newSelection)
    }
  };

  const handleDeleteClickOpen = (id) => {
    setDealerUserId(id);
    setOpen(true);
  };
  const handleDeleteCloseDialog = () => {
    setOpen(false);
  }

  const handleDeleteClose = () => {
    setOpen(false);

    const requestOptions = {
      method: 'DELETE',
      credentials: "include"
    };

    const parameters = new URLSearchParams({
      id: dealerUserId,
    });

    fetch(Constants.baseURL + Constants.apiDeleteDealer + '?' + parameters, requestOptions)
      .then(response => {
        if (!response.ok && response.status !== 404) {
          this.props.history.push('/');
        }

        if (response.ok) {
          parent.getDealersList();
          toast.success('Dealer removed successfully', {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        } else {
          toast.error('Error. Please try again', {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
      })
      .catch(error => { console.log('request failed', error); });
  };

  return (
    <React.Fragment>
      <ToastContainer />

      <Grid
        container
        spacing={1}
        alignItems="center"
        sx={{
          mb: 1,
          flexWrap: { xs: "wrap", sm: "nowrap" },
          justifyContent: { xs: "flex-start", sm: "flex-end" },
          "& .MuiGrid-item": { minWidth: 0, maxWidth: 250 },
        }}
      >
        <Grid
          item
          xs={12}
          sm="auto"
          sx={{
            whiteSpace: "nowrap",
            mr: { xs: 0, sm: "auto" },
          }}
        >
          <Title>Dealers</Title>
        </Grid>

        <Grid item xs={12} sm>
          <TextField
            id="tfName"
            inputRef={tfName}
            label="Name"
            size="small"
            fullWidth
            onKeyDown={(e) => e.key === "Enter" && handleSearch()}
            onChange={onChangeHandler}
          />
        </Grid>

        <Grid item xs={12} sm>
          <TextField
            id="tfEmail"
            inputRef={tfEmail}
            label="Email"
            size="small"
            fullWidth
            onKeyDown={(e) => e.key === "Enter" && handleSearch()}
            onChange={onChangeHandler}
          />
        </Grid>

        <Grid item xs={12} sm="auto">
          <Button variant="contained" type="submit" onClick={() => { handleSearch() }}>Search</Button>
        </Grid>
      </Grid>

      <div style={{ height: 641, width: '100%', 'padding-top': '10px' }}>
        <DataGrid sx={{
          "&.MuiDataGrid-root .MuiDataGrid-cell:focus-within": {
            outline: "none !important",
          },
        }}
          rows={data}
          columns={columns}
          pageSize={10}
          rowsPerPageOptions={[5]}
          checkboxSelection={true}
          selectionModel={selectionModel}
          onSelectionModelChange={handleSelectionModelChange}
          disableSelectionOnClick
        />
        <Dialog
          open={open}
          keepMounted
          onClose={handleDeleteCloseDialog}
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle>{"Remove Dealer"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
              Are you sure you want to remove this dealer?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleDeleteCloseDialog}>No</Button>
            <Button onClick={handleDeleteClose}>Yes</Button>
          </DialogActions>
        </Dialog>
      </div>
    </React.Fragment>
  );
}